import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const legacyPortfolioPagesRoute: InvariantJiraRoute = {
	name: 'legacy-portfolio-pages',
	path: '/secure/PortfolioPlan(\\w+).jspa',
};
